<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="buy-point">
      <Title eng="BUY POINTS" :jpn="t('ポイント購入')" />
      <div class="point_course_area">
        <PointCourse
          v-for="(pointPriceItem) in pointPriceList" :key="pointPriceItem.id"
          class="point-course"
          :point="pointPriceItem.point"
          :price="pointPriceItem.price"
          :memo="pointPriceItem.memo"
          @handleBuyBtnClick="buyPoint(pointPriceItem.id)"
        />
      </div>
      <div class="notation-area">
        <ShadowButton
          class="shadow-button"
          :text="t('特定商取引法に基づく表記')"
          @handleShadowBtnClick="goToSpecificCommerce"
        />
        <ShadowButton
          class="shadow-button"
          :text="t('資金決済法に基づく表記')"
          @handleShadowBtnClick="goToFundSettlement"
        />
        <ShadowButton
          class="shadow-button"
          :text="t('ポイント利用規約')"
          @handleShadowBtnClick="goToPointTermsOfService"
        />
      </div>
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import ShadowButton from '@/components/molecules/ShadowButton.vue';
import PointCourse from '@/components/organisms/PointCourse.vue';
import Title from '@/components/molecules/Title.vue';
import t from '@/plugins/i18n';

export default {
  name: 'BuyPoint',
  mixins: [t],

  components: {
    BaseTemplate,
    ShadowButton,
    PointCourse,
    Title,
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
      pointPriceList: 'pointPrice/pointPriceList',
    }),
  },

  created() {
    const pageNumber = 1;
    this.$store.dispatch('pointPrice/setPointPriceList', { pageNumber });
  },

  methods: {
    buyPoint(pointPriceId) {
      const query = {
        pointPriceId,
      };
      this.$router.push({ path: '/confirm-buy-point', query });
    },
    goToSpecificCommerce() {
      this.$router.push('/specific-commerce');
    },
    goToFundSettlement() {
      this.$router.push('/fund-settlement');
    },
    goToPointTermsOfService() {
      this.$router.push('/point-terms-of-service');
    },
    goToBuyPointHistory() {
      this.$router.push('/buy-point-history');
    },
  },
};
</script>

<style lang="scss" scoped>
.carrer_memo {
  margin-top: 10px;
  color: $black;
  font-size: 80%;
  a {
    color: $black!important;
  }
}
.buy-point{
  width: 100%;
  max-width: 650px;
  min-height: 100%;
  padding: 30px 10px 33px 10px;
  margin: 0 auto;
  text-align: center;
  .point_course_area {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    .point-course{
      width: 100%;
      height: auto;
      border-top: solid 1px $black;
      &:last-child {
        border-bottom: solid 1px $black;
      }
    }
  }
  .notation-area {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-top: 50px;
    .shadow-button {
      width: 255px;
      height: 40px;
      color: $black;
    }
  }
}
@media screen and  (max-width: $tabletWidth) {
  .leaf_area {
    flex-direction: column;
  }
  .buy-point {
    .notation-area {
      margin-top: 20px;
      flex-direction: row;
      white-space: nowrap;
    }
  }
  .shadow-button {
    font-size: 10px;
  }
}
</style>
